(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSitePartDialogController', PublicSitePartDialogController);

    PublicSitePartDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PublicSitePart', 'PublicSitePartKey'];

    function PublicSitePartDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PublicSitePart, PublicSitePartKey) {
        var vm = this;

        vm.publicSitePart = entity;
        vm.clear = clear;
        vm.save = save;
        vm.publicsitepartkeys = PublicSitePartKey.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.publicSitePart.id !== null) {
                PublicSitePart.update(vm.publicSitePart, onSaveSuccess, onSaveError);
            } else {
                PublicSitePart.save(vm.publicSitePart, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('vobeApp:publicSitePartUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
